(function () {
  'use strict';

  if (window.__youtubeFeatureInitialized) return;
  window.__youtubeFeatureInitialized = true;

  let lastTrigger = null;

  const EMBED_PARAMS =
    '?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1';

  function buildSrc(videoId) {
    return (
      'https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      EMBED_PARAMS
    );
  }

  function buildIframe(videoId, label, className) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('title', label || 'YouTube video');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    if (className) iframe.className = className;
    iframe.setAttribute('src', buildSrc(videoId));
    return iframe;
  }

  function allFrames() {
    return document.querySelectorAll(
      '.youtube-feature__inline-frame, [data-youtube-modal-frame] iframe'
    );
  }

  function postCommand(iframe, func) {
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: func, args: [] }),
        '*'
      );
    } catch (e) {
    }
  }

  function pauseOthers(activeIframe) {
    allFrames().forEach(function (frame) {
      if (frame !== activeIframe) postCommand(frame, 'pauseVideo');
    });
  }

  function openModal(modal, videoId, label) {
    const frame = modal.querySelector('[data-youtube-modal-frame]');
    if (!frame) return;

    const iframe = buildIframe(videoId, label);
    iframe.addEventListener('load', function () {
      frame.setAttribute('data-loaded', '');
    });

    frame.removeAttribute('data-loaded');
    frame.innerHTML = '';
    frame.appendChild(iframe);

    pauseOthers(iframe);

    modal.setAttribute('data-open', '');
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('aria-label', label || 'YouTube video');
    document.body.classList.add('youtube-feature--locked');

    const closeBtn = modal.querySelector('[data-youtube-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal.hasAttribute('data-open')) return;

    modal.removeAttribute('data-open');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('youtube-feature--locked');

    const frame = modal.querySelector('[data-youtube-modal-frame]');
    if (frame) {
      frame.removeAttribute('data-loaded');
      frame.innerHTML = '';
    }

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function playInline(section, triggerBtn) {
    const id = triggerBtn.getAttribute('data-youtube-id');
    const label = triggerBtn.getAttribute('data-youtube-label') || 'YouTube video';
    if (!id) return null;

    const iframe = buildIframe(id, label, 'youtube-feature__inline-frame');
    triggerBtn.replaceWith(iframe);

    pauseOthers(iframe);
    return iframe;
  }

  function initSection(section) {
    if (section.dataset.youtubeFeatureBound) return;
    section.dataset.youtubeFeatureBound = '1';

    const modal = section.querySelector('[data-youtube-modal]');
    if (!modal) return;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    section.addEventListener('click', function (event) {
      const inlineTrigger = event.target.closest('[data-youtube-inline]');
      if (inlineTrigger && section.contains(inlineTrigger)) {
        playInline(section, inlineTrigger);
        return;
      }

      const trigger = event.target.closest('[data-youtube-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      const id = trigger.getAttribute('data-youtube-id');
      const label = trigger.getAttribute('data-youtube-label') || '';
      if (!id) return;

      lastTrigger = trigger;
      openModal(modal, id, label);
    });

    modal.addEventListener('click', function (event) {
      if (
        event.target === modal ||
        event.target.closest('[data-youtube-modal-close]')
      ) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.hasAttribute('data-open')) {
        closeModal(modal);
      }
    });
  }

  function init() {
    document
      .querySelectorAll('[data-youtube-feature]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-youtube-feature]');
    if (section) initSection(section);
  });

  function playMainInline() {
    const section = document.querySelector('[data-youtube-feature]');
    if (!section) return;

    const trigger = section.querySelector('[data-youtube-inline]');
    if (trigger) {
      playInline(section, trigger);
    } else {
      const existing = section.querySelector('.youtube-feature__inline-frame');
      if (existing) {
        pauseOthers(existing);
        postCommand(existing, 'playVideo');
      }
    }

    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-liw-watch-video]');
    if (!link) return;
    event.preventDefault();
    playMainInline();
  });
})();
